import { Form } from 'antd';
import { useLocation, Link, useHistory } from 'react-router-dom';
import React from 'react';

import { signInWithGoogle, signInWithEmail } from './authService';
import { AuthLogo, AuthPage, AuthDivider, GoogleButton, EmailForm } from './AuthComponents';
import { useFetchStatusContext } from 'src/hooks/useFetchStatusContext';

const ACTIONS = {
  signinWithGoogle: 'signinWithGoogle',
  signInWithEmail: 'signInWithEmail',
};

const LoginPage = () => {
  const history = useHistory();
  const location = useLocation();
  const asyncAction = useFetchStatusContext();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirect') || '/';

  const [form] = Form.useForm();

  const handleGoogleSignIn = async () => {
    await asyncAction.execute(ACTIONS.signinWithGoogle, async () => {
      const signinUserResponse = await signInWithGoogle();
      if (!signinUserResponse.data.new) {
        window.location.href = redirectUrl;
        return;
      }
      history.push(`/user/project/new`)
    });
  };

  const handleEmailSignIn = async values => {
    await asyncAction.execute(ACTIONS.signInWithEmail, async () => {
      await signInWithEmail(values.email, values.password, redirectUrl);
    });
  };

  return (
    <Form
      form={form}
      name="login"
      initialValues={{ email: '', password: '' }}
      onFinish={handleEmailSignIn}
      autoComplete="off"
      layout="vertical"
    >
      <AuthPage>
        <div>
          <AuthLogo />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <GoogleButton
              onClick={handleGoogleSignIn}
              text="Continue with Google"
              loading={asyncAction.isLoading([ACTIONS.signinWithGoogle])}
              disabled={asyncAction.isLoading([ACTIONS.signinWithGoogle])}
            />
            <AuthDivider />
            <EmailForm
              isLogin={true}
              loading={asyncAction.isLoading([ACTIONS.signInWithEmail])}
              disabled={asyncAction.isLoading([ACTIONS.signInWithEmail])}
            />
            <div style={{ marginTop: 24, textAlign: 'center' }}>
              Don&apos;t have an account? <Link to={`/signup?${searchParams}`}>Sign up</Link>
            </div>
          </div>
        </div>
      </AuthPage>
    </Form>
  );
};

export default LoginPage;
